import { format } from 'date-fns';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const usageFetch = async (path, opts = {}) => {
  const res = await fetch(`${API_URL}/api/usage${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...opts,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.detail || `Request failed (${res.status})`);
  return json;
};

export const rangeQuery = (range) => {
  if (!range?.from) return '?start=all';
  const p = new URLSearchParams({ start: format(range.from, 'yyyy-MM-dd') });
  if (range.to) p.set('end', format(range.to, 'yyyy-MM-dd'));
  return `?${p.toString()}`;
};

export const fmtMinutes = (m) => {
  if (!m) return '0m';
  if (m < 60) return `${Math.round(m)}m`;
  const h = Math.floor(m / 60);
  const r = Math.round(m % 60);
  return r ? `${h}h ${r}m` : `${h}h`;
};

export const fmtAgo = (iso) => {
  if (!iso) return '—';
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
};
